var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('van-nav-bar',{attrs:{"title":"活动专区","left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_vm._v(" activity")],1)}
var staticRenderFns = []

export { render, staticRenderFns }